import React from "react";
import ReactDOM from "react-dom/client";
// Global styles load first so component styles win ties in the cascade.
import "@fontsource-variable/archivo/wdth";
import "./styles/global.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
